// @flow
export { HTMLDescription, HTMLDescriptionSmall } from './HTMLDescription';
